import '../Styles/Toyota.scss'

import React from "react";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container"
import LoadingGif from '../static/images/loading.gif'
function Loader() {
    return(
    <Container>
    <Image className = "working" id = "loadingGIF" src={LoadingGif} aria-hidden = "true" />
    </Container>
    
)}

export default Loader;
